import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { TerminalDto } from '../types/dtos';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.mutation<void, TerminalDto>({
        query: (payload) => ({
            url: `${APP_ENDPOINTS.TERMINALS}`,
            method: 'POST',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'terminals-with-join', id: 'GET-JOIN' },
            { type: 'terminals', id: 'GET' },
            { type: 'place', id: 'GET-ID' },
        ],
    });
